/**
 * Die Nachfrage vor der Freigabe eines Steuerprofils.
 *
 * Vorher löste ein einzelner Klick sie aus. Das ist an drei Stellen zu wenig: `verifyProfile`
 * (services/team.ts) schreibt `verified_at` auf den **contractor**, nicht auf die Zeile dieses
 * Auftraggebers — die Freigabe gilt also bei jedem Auftraggeber, für den dieser Auftragnehmer
 * arbeitet; es gibt keinen Endpunkt, der sie zurücknimmt; und was sie freigibt, ist die Zusage, mit
 * der die Rechnungen dieses Ausstellers künftig ohne Warnung ihren Umsatzsteuer-Hinweis tragen.
 *
 * Deshalb steht hier, was bestätigt wird — Name, Profil, Land —, und die beiden Sätze, die den
 * Klick von einem Häkchen zu einer Entscheidung machen.
 */
import type { ReactElement } from 'react'
import { Dialog } from './Dialog'
import { Knopf } from './Knopf'

export interface SteuerprofilFreigabeDialogProps {
  name: string
  /** Der deutsche Text des Profils — `STEUERPROFIL_TEXT[vat_mode]` beim Aufrufer. */
  profil: string
  laeuft: boolean
  fehler: string | null
  onBestaetigen: () => void
  onSchliessen: () => void
}

export function SteuerprofilFreigabeDialog({
  name, profil, laeuft, fehler, onBestaetigen, onSchliessen,
}: SteuerprofilFreigabeDialogProps): ReactElement {
  return (
    <Dialog titel="Steuerprofil freigeben" offen onSchliessen={onSchliessen}>
      <p className="erklaerung">
        Aussteller: {name}. Bestätigt wird das Steuerprofil <strong>{profil}</strong>.
      </p>
      <p className="erklaerung">
        Die Freigabe gilt plattformweit — bei jedem Auftraggeber, für den dieser Auftragnehmer
        abrechnet, nicht nur bei diesem. Ab dann tragen seine Rechnungen ihren
        Umsatzsteuer-Hinweis ohne Warnung.
      </p>
      <p className="warnung">
        Zurücknehmen lässt sich das hier nicht: es gibt keinen Weg in der Oberfläche, der eine
        Freigabe wieder aufhebt.
      </p>
      {fehler === null ? null : <p role="alert" className="fehler">{fehler}</p>}
      {/* `erstfokus` auf „Abbrechen“, wie bei jeder anderen unumkehrbaren Tat dieser Anwendung:
          die Eingabetaste, die den Dialog geöffnet hat, wiederholt sich, solange sie gehalten wird. */}
      <p className="knoepfe">
        <Knopf disabled={laeuft} onClick={onBestaetigen}>Jetzt freigeben</Knopf>
        <Knopf variante="still" erstfokus onClick={onSchliessen}>Abbrechen</Knopf>
      </p>
    </Dialog>
  )
}
